import { z } from 'zod';

import { ReportableEventInput } from '../loan/ReportableEvent';
import { BaseLoanEvent } from './BaseLoanEvent';

export const UpsertReportableEvent = BaseLoanEvent.extend({
  type: z.literal('upsertReportableEvent'),
  reportableEvent: ReportableEventInput,
});
export type UpsertReportableEvent = z.infer<typeof UpsertReportableEvent>;
